/*export interface TypeCamaras {
    id:        string;
    createdAt: Date;
    updatedAt: Date;
    name:      string;
}*/

export enum SensorDato{
    BOOLEAN = "BOOLEAN",
    INT16 = "INT16",
    INT32 = "INT32",
    FECHA_HORA = "FECHA_HORA",
    FECHA = "FECHA",
    SEMANA_HORA = "SEMANA_HORA",
    DIA_HORA = "DIA_HORA",
    HORA = "HORA",
    REAL = "REAL",
    REAL_DIV_10 = "REAL_DIV_10",
    STRING = "STRING"
}

export enum SensorType{
    TEMPERATURA = "TEMPERATURA", //Valor de Temepratura en ºC -> REAL_DIV_10
    SET_POINT_TEMPERATURA = "SET_POINT_TEMPERATURA", //Valor de Set Point de Temepratura en ºC -> REAL_DIV_10
    HUMEDAD = "HUMEDAD", //Valor de Humedad en % -> REAL_DIV_10
    PRESION = "PRESION", //Valor de Presion en Bar -> REAL_DIV_10
    SET_POINT_PRESION = "SET_POINT_PRESION", //Valor de Set Point de Presion en Bar -> REAL_DIV_10
    CAPACIDAD = "CAPACIDAD", //Valor de Capacidad en % -> INT16
    POTENCIA = "POTENCIA", //Valor de Potencia en KW -> INT32
    SET_POTENCIA = "SET_POTENCIA", //Valor de Set Point de Potencia en KW -> INT32
    TENSION = "TENSION", //Valor de Tension en V -> INT32
    CORRIENTE = "CORRIENTE", //Valor de Corriente en A -> INT32
    COSENO_PHI = "COSENO_PHI", //Valor de Cosenso Phi -> REAL
    VELOCIDAD_HZ = "VELOCIDAD_HZ", //Valor de Velocidad en Hz -> REAL_DIV_10
    VELOCIDAD_100 = "VELOCIDAD_100", //Valor de Velocidad en % -> INT16
    APERTURA_VALVULA = "APERTURA_VALVULA", //Valor de Apertura Valvula Capacidad en % -> INT16
    MENSAJE_FUNCIONAMIENTO = "MENSAJE_FUNCIONAMIENTO", //Mensaje general de funcionamiento de Camaras, Sala de Maquinas, etc. -> STRING
    ESTADO_VENTILADORES = "ESTADO_VENTILADORES", // ON-OFF Ventiladores -> BOOLEAN 
    ESTADO_SOL_ASPIRACION = "ESTADO_SOL_ASPIRACION", // ON-OFF Sol. de Aspiracion -> BOOLEAN 
    ESTADO_SOL_LIQUIDO = "ESTADO_SOL_LIQUIDO", // ON-OFF Sol. de Liquido -> BOOLEAN 
    ESTADO_SOL_DESHIELO = "ESTADO_SOL_DESHIELO", // ON-OFF Sol. de Deshielo -> BOOLEAN 
    ESTADO_VALVULA = "ESTADO_VALVULA", // ON-OFF Vavula -> BOOLEAN 
    ESTADO_COMPRESOR = "ESTADO_COMPRESOR", // ON-OFF Motor Compresor -> BOOLEAN 
    ESTADO_TORNILLO = "ESTADO_TORNILLO", // ON-OFF Motor Compresor Tornillo-> BOOLEAN 
    ESTADO_BOMBA = "ESTADO_BOMBA", // ON-OFF Motor Bomba  -> BOOLEAN 
}

export enum SensorColor{
    RED = "RED",
    BLUE = "BLUE",
    GREEN = "GREEN",
    BLACK = "BLACK",
    ORANGE = "ORANGE",
    YELLOW = "YELLOW",
    PURPLE = "PURPLE",
    PINK = "PINK",
    BROWN = "BROWN",
    WHITE = "WHITE",
}

export enum CamaraType{
    CAMARA_AMONIACO = "CAMARA_AMONIACO", //Representa una Camara de Amoniaco con Ventiladores, Sol. de Aspiracion y Liquido, Sol, Deshielo, etc,
    CAMARA_GLICOL = "CAMARA_GLICOL", //Representa una Camara de Glicol con Ventiladores, Bomba GLicol, Valvula Glicol, Sol, Deshielo, etc,
    COMPRESOR = "COMPRESOR", //Representa un Compresor con Estado Funcionamiento, Capacidad, etc
    SALA_MAQUINAS = "SALA_MAQUINAS", //Representa los sensores de presion , Estados general de funcionamiento, etc.
    MEDIDAS_ELECTRICAS = "MEDIDAS ELECTRICAS", //Representa los valores de medidas electricas: potencia, tension, corriente, etc.
}

export interface TypeValor {
    fecha_hora_value: string | undefined,
    value: string | undefined,
}

export interface TypeSensor  {
    id: string,
    name_db: string,
    name_front:string,
    descripcion: string | undefined,
    tipo_dato: SensorDato,
    tipo_sensor: SensorType,
    color_front: SensorColor,
    max_grafico: number,
    min_grafico: number,
    valores: TypeValor[],
    color_fondo: string,
    color_fuente: string,
    /*value: string | undefined,
    fecha_hora_value: string | undefined,*/
}

export interface TypeCamaras  {
    id: string,
    name: string,
    tipo: CamaraType,
    sensores: TypeSensor[]
}

export interface TypeFrioCamSenValor {
    frio: {
        id: string,
        name: string
    },
    camaras : TypeCamaras[]
}